import React, { Component, Fragment, } from 'react';
import {updateProfile, getProfile} from '../api.js';
import BreadCrumb from './BreadCrumb';
import defaultAvatar2 from '../img/icons-2025/user/user.svg';
import ContentBox from './ContentBox.js';
import {formatRut, checkRut, validatePassword} from '../utils.js';
import Tooltip  from 'rc-tooltip';
import TagManager from 'react-gtm-module';
import moment from 'moment';

export default class EditarPerfil extends Component {
	constructor(props) {
		super(props);
		this.state = {
			notification_check: null,
			password_duplicate: null,
			name: '',
			last_name: '',
			dni: '',
			phone: '',
			password: '',
			password_confirmation: '',
			showErrorMessage: {
				password: true,
				password_confirmation: true
			},
			user: {},
			errors: [],
		};

		this.gtmTimeout = null;
		this.debounceTimeout = null;
	}

	componentDidMount() {
		this.props.changeHeaderClass("medium");
		this.loadProfile();
	}
	componentWillUnmount() {
		clearTimeout(this.gtmTimeout);
		clearTimeout(this.debounceTimeout);
	}

	sendCustomEventGTM({event, metadata={}, delay = 0}){
		if (!event) return;
		const { dni, errors, name, last_name, phone, user: { email, id, sales_force_id } } = this.state;

		clearTimeout(this.gtmTimeout);
		this.gtmTimeout = setTimeout(() => {
			TagManager.dataLayer({ 
				dataLayer:{ event, metadata:{
					id,
					sales_force_id,
					dni,
					name,
					last_name,
					phone,
					email,
					errors,
					...metadata
				}} 
			});
		}, delay);
	}

	loadProfile(){
		getProfile(this.props.user.id, (error, result) => {			
			if(result){
				if(result.status === "ok") {
					var user = result.data[this.props.isEmpresas?"company_user":"person"];
					this.props.updateUser(user);
					this.setState({
						user,
						notification_check: parseInt(user.notification_check) === 1 ? true : false,
						name: user.name,
						last_name: user.last_name,
						dni: user.dni,
						phone: user.phone,
						profile_picture: user.profile_picture
					}, () => {});
				}
			}
			this.sendCustomEventGTM({event:"sv_editar_perfil_visita", metadata:{trigger:"load-profile"}});
		}, this.props.isEmpresas?"empresas":null);
	}

	submitUpdateProfile = () => {
		const { name, dni, last_name, phone, password, password_confirmation, notification_check, password_duplicate } = this.state;
		const { id, email } = this.props.user;
		const body = {id, dni, name, last_name, phone, password, password_confirmation, notification_check, password_duplicate};

		updateProfile(body, (error, result) => {
			this.sendCustomEventGTM({event:"sv_editar_perfil_click_actualizar", metadata:{ request: {result: result.status, error}}});

			if(error) return console.log("ocurrió un error con el request");
			
			if(result.status === "error" && result.errors) {
				this.setState({ 
					showErrorMessage: {
						password: true,
						password_confirmation: true
					},
					errors: result.errors 
				});
			}

			if(result.status === "ok") {
				this.loadProfile();
				this.props.createActionNotification("Edición completada", "Datos actualizados correctamente");
			}
		}, this.props.isEmpresas?"empresas":null);
	}
	onPasswordChange = (e, field_name) => {
		if(!field_name in this.state) return;

		this.deleteFormError(field_name);
		const value = e.target.value;
		const { isPasswordValid, textPasswordHelp } = validatePassword(value);
		
		if(!isPasswordValid) this.addErrorByField(field_name, textPasswordHelp);
		
		this.setState({ [field_name]: value }, ()=>{
			this.sendCustomEventGTM({event:"sv_editar_perfil_interaccion_campos",delay:300})
		});
	}
	addErrorByField(field_name, text) {
		if(!field_name in this.state) return;

		const errors = {
			...this.state.errors,
			[field_name]: text
		};
	
		this.setState({ errors });
	}
	deleteFormError(field_name) {
		var formErrors = {...this.state.errors};
		delete formErrors[field_name];
		this.setState({errors: formErrors})
	}

	render() {
		var breadCrumbOptions = [
			{title: "Mis Servicios"},
			{title: "Editar Perfil"},
		];
		var profilePicture = this.state.profile_picture?this.state.profile_picture:defaultAvatar2;
		const {password, password_confirmation, errors, showErrorMessage} = this.state;
		const isDisabledUpdate =  !password.trim() || password.trim().length > 64 || password !== password_confirmation;
		const isToolTipVisible = {
			password: Boolean(errors.password) && showErrorMessage.password,
			password_confirmation: Boolean(errors.password_confirmation) && showErrorMessage.password_confirmation
		}

		return (
			<Fragment>
				<div className="section-title">
					<h1>Mi cuenta</h1>
					<BreadCrumb options={breadCrumbOptions} />
				</div>

				<ContentBox className="py-7 px-6">
					<section className="edit-profile-container d-flex flex-mobile-column gap-4">
						<div className="p-6 rounded-xl" style={{border:"1px solid #E5E7EB", flex:1}}>
							<h3 className="font-20">
								Información personal
							</h3>

							<div className='mt-12 d-flex flex-mobile-column-important gap-8'>
								<img className="size-14 mx-mobile-auto" src={profilePicture} alt="Imagen Perfil"/>

								<div className='d-flex flex-column flex-mobile-column-important gap-4' style={{fontSize:"1rem", flex:"1 1 0", minWidth: 0, overflowWrap: "break-word"}}>
									<p>
										<span className='block-important' style={{color:"#6A7282"}}>
											Nombre Completo
										</span>
										{this.props.user.name} {this.props.user.last_name}
									</p>
									
									<p>
										<span className='block-important' style={{color:"#6A7282"}}>
											Email
										</span>
										{this.props.user.email}	
									</p>
								</div>

								<div className='d-flex flex-column flex-mobile-column-important gap-4' style={{fontSize:"1rem", flex:"1 1 0", minWidth: 0, overflowWrap: "break-word"}}>
									<p style={{minHeight:48}}>
										<span className='block-important' style={{color:"#6A7282"}}>
											Teléfono
										</span>
										{this.state.phone}
									</p>
									<p style={{minHeight:48}}>
										<span className='block-important' style={{color:"#6A7282"}}>
											RUT
										</span>
										{formatRut(this.state.dni)}
									</p>
								</div>
							</div>

							<div className='mt-32 p-3 gap-2 align-items-center rounded-xl' style={{color:"#2D9CDB", border:"1px solid", backgroundColor:"#2D9CDB1A", display:"flex", width:'100%'}}>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink:0}}>
									<path d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor"/>
								</svg>

								<p className='w-full fw600'>
									Estos datos son verificados previamente y no pueden ser modificados desde este portal. Para cambios, contacta a servicio al cliente.
								</p>
							</div>
						</div>
								
						<div className="p-6 rounded-xl" style={{border:"1px solid #E5E7EB", flex:1}}>
							<h3 className="font-20 flex flex-mobile align-items-center gap-2" style={{width:'100%'}}>
								<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink:0}}>
									<path d="M8.04006 17.1103C7.20886 17.1103 6.50302 16.82 5.92255 16.2395C5.34207 15.6591 5.05183 14.9532 5.05183 14.122C5.05183 13.2908 5.34207 12.585 5.92255 12.0045C6.50302 11.424 7.20886 11.1338 8.04006 11.1338C8.87126 11.1338 9.5771 11.424 10.1576 12.0045C10.7381 12.585 11.0283 13.2908 11.0283 14.122C11.0283 14.9532 10.7381 15.6591 10.1576 16.2395C9.5771 16.82 8.87126 17.1103 8.04006 17.1103ZM8.04006 20.3116C9.47924 20.3116 10.7346 19.9046 11.8061 19.0905C12.8777 18.2762 13.5591 17.2442 13.8504 15.9944H16.0824L17.4025 17.1703C17.4838 17.2443 17.5688 17.2986 17.6574 17.3332C17.7463 17.368 17.841 17.3854 17.9415 17.3854C18.0421 17.3854 18.1348 17.368 18.2198 17.3332C18.305 17.2986 18.3919 17.2406 18.4806 17.1593L20.2422 15.575L21.8039 17.0705C21.8928 17.1518 21.9852 17.2117 22.0814 17.2501C22.1775 17.2886 22.2795 17.3042 22.3874 17.2969C22.4879 17.2969 22.5845 17.2776 22.6769 17.2392C22.7694 17.2007 22.86 17.1407 22.9486 17.0592L25.3713 14.67C25.4674 14.5812 25.5347 14.4887 25.5732 14.3926C25.6116 14.2964 25.6309 14.1944 25.6309 14.0866C25.6309 13.9712 25.6116 13.8673 25.5732 13.7748C25.5347 13.6823 25.4712 13.588 25.3825 13.4919L24.3419 12.4625C24.2531 12.3739 24.1606 12.3084 24.0645 12.2661C23.9684 12.224 23.8626 12.2029 23.7472 12.2029H13.8504C13.497 10.9887 12.8118 9.97342 11.7949 9.15703C10.7781 8.34063 9.52653 7.93243 8.04006 7.93243C6.30959 7.93243 4.84533 8.53137 3.64727 9.72924C2.4494 10.9273 1.85046 12.3916 1.85046 14.122C1.85046 15.8525 2.4494 17.3168 3.64727 18.5148C4.84533 19.7127 6.30959 20.3116 8.04006 20.3116Z" fill="#FE5000"/>
								</svg>
								Restablecer contraseña
							</h3>
							
							<form className="w-full flex-column gap-4 mt-4" onSubmit={(e) => e.preventDefault() } style={{display:"flex"}} >
								<Tooltip 
								placement="bottom" 
								visible={isToolTipVisible.password}
								overlay={<span style={{ whiteSpace: 'pre-line' }}> {errors.password } </span>}>
									<label className='fw600'>
										Ingresa la nueva contraseña
										<input
										type="password"
										maxLength={64}
										name='editar-input-password'
										className='mt-8 rounded-2xl'
										value={this.state.password} 
										onChange={e => this.onPasswordChange(e, 'password')}
										onBlur={()=> this.setState({ showErrorMessage: { ...showErrorMessage, password: false } }) } 
										onFocus={()=> this.setState({ showErrorMessage: { ...showErrorMessage, password: true } }) } 
										/>
									</label>
								</Tooltip>
								<Tooltip 
								placement="bottom" 
								visible={isToolTipVisible.password_confirmation}
								overlay={<span style={{ whiteSpace: 'pre-line' }}> {errors.password_confirmation } </span>}>
									<label className='fw600'>
										Repite la nueva contraseña
										<input
										type="password"
										maxLength={64}
										name='editar-input-password-confirm'
										className='mt-8 rounded-2xl'
										value={this.state.password_confirmation} 
										onChange={(e) => {
											const {value} = e.target;
											this.setState({password_confirmation: value},() => {
												if(value === password) return this.deleteFormError('password_confirmation');
												this.addErrorByField('password_confirmation', 'Las contraseñas no coinciden');
											})
										}}
										onBlur={()=> this.setState({ showErrorMessage: { ...showErrorMessage, password_confirmation: false } }) } 
										onFocus={()=> this.setState({ showErrorMessage: { ...showErrorMessage, password_confirmation: true } }) } 
										/>
									</label>
								</Tooltip>
								<button 
								type="button" 
								disabled={isDisabledUpdate}
								style={isDisabledUpdate ? { pointerEvents: 'none', opacity: 0.8 } : {}}
								className="w-full button orange col-inherit uppercase" 
								onClick={()=>{
									if (isDisabledUpdate) return;
									this.submitUpdateProfile();
								}}>
									CAMBIAR CONTRASEÑA
								</button>
								{this.state.user && this.state.user.updated_at && 
									<span className='font-12' style={{color:"#6A7282"}}>
										Última modificación: {moment(this.state.user.updated_at, "YYYY-MM-DD HH:mm:ss.SSS").format("DD/MM/YYYY")}
									</span>
								}
							</form>
						</div>	
					</section>

					<div className="col-100 d-flex gap-4 mt-20">
						<div className='col-50' />
						<label htmlFor="notification_check" className="checkbox-container">
							<input 
							id="notification_check" 
							type="checkbox" 
							checked={this.state.notification_check} 
							onChange={(e) => {
								this.setState({notification_check: !this.state.notification_check});
								this.sendCustomEventGTM({event:"sv_editar_perfil_click_envio_notificaciones"})
							}}/>
							<span className="checkmark checkbox-with-border"></span>
							<span>Deseo activar el envío de notificaciones</span>
						</label>
					</div>

					{typeof this.props.user.second_account !== 'undefined' && this.props.user.second_account &&
						<div className="col-100 mt-20">
							<label htmlFor="password_duplicate" className="checkbox-container">
								<input id="password_duplicate" type="checkbox" checked={this.state.password_duplicate ? true : false} onChange={(e) => {this.setState({password_duplicate: !this.state.password_duplicate})}}/>
								<span className="checkmark checkbox-with-border"></span>
								<span>Sincroniza contraseña con cuenta Persona natural (Email: <strong>{this.props.user.seccond_email}</strong>)</span>
							</label>
						</div>
					}
				</ContentBox>
			</Fragment>
		);
	}
}
